var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-snotify'), _c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm.isOAChatroom ? [_c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("LINE 應用中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("LINE 聊天")])] : [_c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("我的主控台")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("聊天室總覽")])]], 2), _c('div', {
    staticClass: "ml-auto d-flex align-items-center"
  }, [_vm.$permissions.hasAny([_vm.$permissions.consts.CHATROOM_LIST_SHOW_MOBILE_CHATROOM_LINK, _vm.$permissions.consts.CHATROOM_LIST_SHOW_SALES_BIND_LINK]) ? _c('b-dropdown', {
    staticClass: "mr-3",
    attrs: {
      "variant": "secondary"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "mdi mdi-menu"
  })]), _vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_SHOW_MOBILE_CHATROOM_LINK) ? _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.$refs.chatroomUrlModal.showMobileChatroomLink();
      }
    }
  }, [_vm._v(" 手機版對話連結 ")]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.CHATROOM_LIST_SHOW_SALES_BIND_LINK) ? _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.$refs.chatroomUrlModal.showSalesBindLink();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.salesBindLinkText) + " ")]) : _vm._e()], 2) : _vm._e(), _vm.newestNotification && _vm.$permissions.has(_vm.$permissions.consts.MY_NOTIFICATION_LATEST) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'BranchNotificationDetail',
        params: {
          notification_id: _vm.newestNotification.id
        }
      }
    }
  }, [_c('i', {
    class: {
      'fa fa-envelope-o text-danger': !_vm.newestNotification.is_read,
      'fa fa-envelope-open-o text-black': _vm.newestNotification.is_read
    }
  }), _c('a', {
    staticClass: "ml-2 text-black",
    class: {
      'text-danger': !_vm.newestNotification.is_read
    }
  }, [_vm._v(" " + _vm._s(_vm.newestNotification.title) + " : " + _vm._s(_vm.format(new Date(_vm.newestNotification.publish_at), "MM/dd HH:mm")) + " ")])])], 1) : _vm._e()], 1)], 1)])]), _c('b-card', {
    ref: "chatroom",
    staticClass: "chatroom",
    attrs: {
      "no-body": ""
    },
    on: {
      "mouseup": function mouseup($event) {
        _vm.isLeftDragging = _vm.isRightDragging = _vm.isBottomDragging = false;
      },
      "mousemove": _vm.onDrag
    }
  }, [_c('div', {
    ref: "chatlist",
    staticClass: "chat-list position-relative border-right"
  }, [_c('div', {
    staticClass: "chat-list-wrapper d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "header px-3 pt-3 pb-2 border-bottom"
  }, [_c('div', {
    staticClass: "search mb-2"
  }, [_vm.canShowBranchSelector ? _c('b-form-select', {
    attrs: {
      "value": _vm.selectedBranch,
      "options": _vm.branchOptions,
      "disabled": _vm.changingBranch
    },
    on: {
      "change": _vm.handleChangeSelectedBranch
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": ""
          }
        }, [_vm._v("-- 選擇分店 --")]), _vm.isOAChatroom ? _c('b-form-select-option', {
          attrs: {
            "value": "unallocated"
          }
        }, [_vm._v("尚未分配")]) : _vm._e()];
      },
      proxy: true
    }], null, false, 672028867)
  }) : _vm._e()], 1), _c('div', {
    staticClass: "search mb-2"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"
    }
  })]), _c('b-form-input', {
    attrs: {
      "type": "search",
      "placeholder": "姓名搜尋"
    },
    on: {
      "input": _vm.keywordSearchDebounced
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "keyword"
    }
  })], 1), _c('div', {
    staticClass: "d-flex flex-wrap"
  }, [_c('div', {
    staticClass: "flex-fill mr-2"
  }, [_vm.allowFilterCategory ? _c('ChatroomMultiselect', {
    attrs: {
      "title": "訊息類型",
      "filters": _vm.filterCategoryOptions,
      "showKeywordFilter": false,
      "selectedOptions": _vm.selectedCategoryFilter
    },
    on: {
      "click": _vm.handleSelectedCategory
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "flex-fill mr-2"
  }, [_vm.allowFilterStatus ? _c('ChatroomMultiselect', {
    attrs: {
      "title": "處理狀態",
      "filters": _vm.statusOptions,
      "showKeywordFilter": false,
      "selectedOptions": _vm.selectedStatus
    },
    on: {
      "click": _vm.handleSelectedStatus
    }
  }) : _vm._e()], 1), _vm.canShowUnreadFilter ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary unread px-2",
    class: _vm.filteredUnreadChatroom ? 'active' : '',
    attrs: {
      "id": "filteredUnreadChatroom"
    },
    on: {
      "click": function click($event) {
        _vm.handleSelectedStatus(_vm.statusOptions.find(function (status) {
          return status.value == 'unread';
        }));
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid icon-all",
    attrs: {
      "src": "data:image/png;base64,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",
      "alt": "顯示未讀訊息"
    }
  }), _c('img', {
    staticClass: "img-fluid icon-unread",
    attrs: {
      "src": "data:image/png;base64,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",
      "alt": "顯示全部訊息"
    }
  })]), _c('b-tooltip', {
    attrs: {
      "target": "filteredUnreadChatroom",
      "triggers": "hover"
    }
  }, [_vm._v(" " + _vm._s(_vm.filteredUnreadChatroom ? "顯示全部訊息" : "顯示未讀訊息") + " ")])], 1) : _vm._e()]), false ? _c('div', {
    staticClass: "filter"
  }, [_c('b-dropdown', {
    attrs: {
      "id": "dropdown-1",
      "text": "所有收件匣",
      "variant": "light"
    }
  }, _vm._l(_vm.filters, function (i) {
    return _c('b-dropdown-item', {
      key: i.id
    }, [_c('i', {
      class: [i.icon],
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(i.id) + " ")]);
  }), 1)], 1) : _vm._e()]), _c('b-list-group', {
    ref: "chatroomList",
    staticClass: "list list-group-flush flex-fill",
    on: {
      "scroll": _vm.handleChatroomListScroll
    }
  }, [!_vm.initialized || _vm.changingBranch || _vm.changingFilter || _vm.keywordFilter ? _c('b-list-group-item', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1)]) : _vm.orderedChatrooms.length > 0 ? [_vm._l(_vm.orderedChatrooms, function (chatroom) {
    return _c('div', {
      key: chatroom.id,
      on: {
        "click": function click($event) {
          return _vm.selectChatroom(chatroom);
        }
      }
    }, [_c('ChatroomListItem', {
      attrs: {
        "role": "button",
        "chatroom": chatroom,
        "variant": _vm.chatroomId == chatroom.id ? 'secondary' : 'default',
        "staffID": _vm.staffId,
        "categories": _vm.categoryFilterOptions
      }
    })], 1);
  }), _vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e()] : _c('b-list-group-item', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "mt-3 text-dark small"
  }, [_vm._v("目前沒有名單")])])], 2)], 1)]), _c('div', {
    staticClass: "left-dragbar",
    on: {
      "mousedown": function mousedown($event) {
        _vm.isLeftDragging = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "chat-box d-flex flex-column"
  }, [_c('div', {
    staticClass: "chat-header"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between px-3 py-2 pe-0 border-bottom"
  }, [_vm.selectedChatroom ? _c('div', {
    staticClass: "font-weight-bold text-truncate"
  }, [_c('b-avatar', {
    staticClass: "mr-1"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.getStaffAvatar(_vm.selectedChatroom)
    }
  })]), _c('b-avatar', {
    staticClass: "mr-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.getCustomerAvatar(_vm.selectedChatroom)
    }
  })]), _vm._v(" " + _vm._s(_vm.getChatroomTitle(_vm.selectedChatroom, true)) + " ")], 1) : _vm._e(), _vm.selectedChatroom ? _c('div', {
    staticClass: "d-flex flex-fill justify-content-end align-items-center"
  }, [false ? _c('b-button', {
    staticClass: "py-1",
    on: {
      "click": function click() {
        var msg = Object.assign(_vm.messages[1]);
        _vm.messages = [msg].concat(_vm.messages);
        _vm.unread = true;
      }
    }
  }, [_vm._v(" Test Message")]) : _vm._e(), _vm.canShowPinButton ? _c('b-button', {
    staticClass: "mx-1 text-nowrap",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled || !_vm.canShowChatReply || !_vm.isSenderEnabled,
      "variant": "".concat(_vm.isSelectedChatroomPinned ? 'warning' : 'outline-warning')
    },
    on: {
      "click": _vm.handleClickPin
    }
  }, [_vm._v(" " + _vm._s(_vm.isSelectedChatroomPinned ? "取消釘選" : "釘選") + " "), _c('i', {
    staticClass: "fa fa-thumb-tack",
    staticStyle: {
      "transform": "rotate(45deg)"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.canShowStatusButtons ? [_c('b-dropdown', {
    ref: "Filter",
    staticClass: "filter mx-1",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled || !_vm.canShowChatReply || !_vm.isSenderEnabled,
      "variant": "".concat(_vm.selectedChatroomStatusVariant, " py-1")
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "flex-fill"
        }, [_vm._v(" " + _vm._s(_vm.selectedChatroomStatusName) + " ")])];
      },
      proxy: true
    }], null, false, 227828262)
  }, _vm._l(_vm.statusOptions.filter(function (status) {
    return status.value !== 'unread';
  }), function (status) {
    return _c('div', {
      key: status.value,
      staticClass: "item py-1 px-3",
      on: {
        "click": function click($event) {
          return _vm.handleClickChangeStatus(status.value);
        }
      }
    }, [_c('span', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('i', {
      class: "".concat(_vm.selectedChatroomStatus === status.value || !_vm.selectedChatroomStatus && status.value === 'not-setting' ? 'fa fa-check' : '', " mr-3"),
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('span', {
      class: "mb-0 px-3 py-2 badge badge-".concat(status.variant, " flex-fill cursor-pointer")
    }, [_vm._v(_vm._s(status.text))])])]);
  }), 0)] : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_vm.showRecallCheckBox ? _c('div', [_c('b-button', {
    staticClass: "m-1",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled || !_vm.canShowChatReply || !_vm.isSenderEnabled,
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.switchShowRecallCheckBox
    }
  }, [_vm._v(" 取消 ")]), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled || !_vm.canShowChatReply || !_vm.isSenderEnabled,
      "variant": "danger"
    },
    on: {
      "click": _vm.recallMessage
    }
  }, [_vm._v(" 收回 ")])], 1) : _vm._e(), _vm.canShowRecall ? [_c('b-dropdown', {
    ref: "settingDropdown",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled || !_vm.canShowChatReply || !_vm.isSenderEnabled,
      "variant": "secondary py-1"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "flex-fill"
        }, [_c('i', {
          staticClass: "fa fa-gear",
          attrs: {
            "aria-hidden": "true"
          }
        })])];
      },
      proxy: true
    }], null, false, 2403027830)
  }, [_c('span', {
    staticClass: "\n                      d-flex\n                      justify-content-between\n                      align-items-center\n                      text-center\n                    ",
    on: {
      "click": _vm.switchShowRecallCheckBox
    }
  }, [_c('span', {
    class: "mb-0 px-3 py-2 flex-fill cursor-pointer"
  }, [_vm._v("收回訊息")])])])] : _vm._e()], 2), false ? _c('b-button', {
    staticClass: "mx-1 text-nowrap",
    attrs: {
      "variant": "outline-dark"
    },
    on: {
      "click": function click() {
        _vm.isMessageSearching = !_vm.isMessageSearching;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 搜尋")]) : _vm._e(), false ? _c('b-button', {
    staticClass: "mx-1",
    attrs: {
      "variant": "light"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in m-0",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), false ? _c('b-button', {
    staticClass: "mx-1",
    attrs: {
      "variant": "light"
    }
  }, [_c('i', {
    staticClass: "fa fa-check m-0 text-success",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 2) : _vm._e()]), _vm.isMessageSearching ? _c('div', {
    staticClass: "search-message p-2 border-bottom d-flex"
  }, [_c('b-form-input', {
    staticClass: "flex-fill",
    attrs: {
      "size": "sm",
      "type": "search",
      "placeholder": "輸入搜尋內容"
    }
  }), _c('b-button', {
    staticClass: "btn btn-light ml-2",
    on: {
      "click": function click() {
        _vm.isMessageSearching = !_vm.isMessageSearching;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])], 1) : _vm._e()]), _c('div', {
    ref: "messages",
    staticClass: "messages d-flex flex-column-reverse flex-fill px-3",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm.chatroomLoaded && !_vm.messages.length ? _c('div', {
    staticClass: "message-box my-2"
  }, [_c('div', {
    staticClass: "strike small text-muted pb-2"
  }, [_vm._v("對話開始")])]) : _vm._e(), _vm._l(_vm.messages, function (message, idx) {
    return _c('ChatroomMessage', {
      key: idx,
      attrs: {
        "messages": _vm.messages,
        "message": message,
        "index": idx,
        "senders": _vm.senders,
        "showMultiDownload": _vm.canShowMultiDownload,
        "showThumbnailMultiDownload": _vm.canShowThumbnailMultiDownload,
        "showRecall": _vm.showRecallCheckBox,
        "canRecallHours": _vm.canShowRecallHours,
        "first-unread-message": _vm.firstUnreadMessage,
        "selectedRecallMessages": _vm.selectedRecallMessages,
        "messageRecalling": _vm.messageRecalling,
        "first-message": _vm.firstMessage,
        "first-load": _vm.firstLoad,
        "first-new-message": _vm.firstNewMessage
      },
      on: {
        "change": _vm.pushRecallMessage
      }
    });
  }), _vm.typingSenders.length ? _c('div', {
    staticClass: "typing-list"
  }, _vm._l(_vm.typingSenders, function (sender) {
    return _c('div', {
      key: sender.id,
      staticClass: "message-box my-2"
    }, [_c('div', {
      staticClass: "message-wrapper"
    }, [_c('div', {
      staticClass: "d-flex align-items-start"
    }, [_c('b-avatar', {
      staticClass: "mr-2",
      attrs: {
        "src": sender.avatar_url
      }
    }), _c('div', [_c('small', [_vm._v(_vm._s(_vm.senderName(sender)))]), _c('div', {
      staticClass: "message py-2 px-3 mt-1"
    }, [_c('Typing')], 1)])], 1)])]);
  }), 0) : _vm._e(), _vm.selectedChatroom && !_vm.loading ? _c('div', {
    staticClass: "text-muted small load-more"
  }, [_vm.nextCursor ? _c('button', {
    staticClass: "btn btn-secondary btn-small",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.loadMore.apply(null, arguments);
      }
    }
  }, [_vm._v(" 載入之前的對話 ")]) : !_vm.firstLoad ? _c('span', [_vm._v("已無對話紀錄")]) : _vm._e()]) : _vm._e(), _vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-auto loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e()], 2), _c('StickerPanel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showStickerPanel,
      expression: "showStickerPanel"
    }],
    attrs: {
      "sticker-packages": _vm.stickerPackages,
      "stickers": _vm.stickers
    },
    on: {
      "package-selected": _vm.fetchStickers,
      "sticker-selected": _vm.handleStickerSelected,
      "close": function close($event) {
        _vm.showStickerPanel = false;
      }
    }
  })], 1), _c('div', {
    staticClass: "bottom-dragbar",
    on: {
      "mousedown": function mousedown($event) {
        _vm.isBottomDragging = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    ref: "chatTypebox",
    staticClass: "chat-typebox"
  }, [_c('div', {
    staticClass: "border-top chat-typebox-wrapper d-flex flex-column"
  }, [_vm.showIndicator ? _c('div', {
    staticClass: "position-absolute unread d-flex justify-content-center px-3"
  }, [_vm.unread ? _c('b-button', {
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('div', {
    staticClass: "last-message-wrapper"
  }, [_vm._v(" " + _vm._s(_vm.latestMessage.sender.name) + "：" + _vm._s(_vm.latestMessage.content) + " ")])]) : !_vm.bottom ? _c('b-button', {
    staticClass: "px-2",
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512",
      "height": "16",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
    }
  })])]) : _vm._e()], 1) : _vm._e(), _vm.selectedChatroom && (_vm.allowSendMessage || _vm.allowSendImage || _vm.allowSendFile) ? [_c('div', {
    staticClass: "\n              p-2\n              chat-typebox-buttons\n              flex-shrink-0\n              list-group-item-secondary\n            "
  }, [_c('b-modal', {
    ref: "imageModal",
    staticClass: "modal-image",
    attrs: {
      "id": "modal-image-upload",
      "title": "傳送照片",
      "centered": "",
      "hide-footer": ""
    }
  }, [_vm.uploading ? _c('div', [_vm._v("上傳中...")]) : _c('b-form-file', {
    ref: "imageUploader",
    staticClass: "uploader",
    attrs: {
      "drop-placeholder": "Drop file here...",
      "accept": "image/*",
      "multiple": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.handleUpload
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function fn(_ref) {
        var names = _ref.names;
        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))])];
      }
    }], null, false, 3778198266)
  }, [_c('template', {
    slot: "placeholder"
  }, [_c('div', {
    staticClass: "\n                      dropzone\n                      d-flex\n                      flex-column\n                      align-items-center\n                      justify-content-center\n                    "
  }, [_c('div', [_vm._v("請將檔案拖放至此")]), _c('div', [_vm._v("或")]), _c('div', [_vm._v("選擇檔案")])])])], 2)], 1), _c('b-modal', {
    ref: "fileModal",
    staticClass: "modal-image",
    attrs: {
      "id": "modal-file-upload",
      "title": "傳送檔案",
      "centered": "",
      "hide-footer": ""
    }
  }, [_vm.uploading ? _c('div', [_vm._v("上傳中...")]) : _c('b-form-file', {
    ref: "fileUploader",
    staticClass: "uploader",
    attrs: {
      "drop-placeholder": "Drop file here...",
      "multiple": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.handleUpload
    },
    scopedSlots: _vm._u([{
      key: "file-name",
      fn: function fn(_ref2) {
        var names = _ref2.names;
        return [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v(_vm._s(names[0]))])];
      }
    }], null, false, 3778198266)
  }, [_c('template', {
    slot: "placeholder"
  }, [_c('div', {
    staticClass: "\n                      dropzone\n                      d-flex\n                      flex-column\n                      align-items-center\n                      justify-content-center\n                    "
  }, [_c('div', [_vm._v("請將檔案拖放至此")]), _c('div', [_vm._v("或")]), _c('div', [_vm._v("選擇檔案")])])])], 2)], 1), _vm.selectedChatroom && _vm.canShowChatReply ? [_c('button', {
    staticClass: "btn btn-link px-2 text-dark",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.showStickerPanel = !_vm.showStickerPanel;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm.allowSendImage ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-image-upload",
      modifiers: {
        "modal-image-upload": true
      }
    }],
    staticClass: "btn btn-link px-2 text-dark",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.allowSendFile ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-file-upload",
      modifiers: {
        "modal-file-upload": true
      }
    }],
    staticClass: "btn btn-link px-2 text-dark",
    attrs: {
      "disabled": !_vm.selectedChatroom.is_enabled
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "py-2 pl-2 border-top d-flex align-items-stretch flex-fill"
  }, [_c('form', {
    staticClass: "flex-fill message-form",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_vm.allowSendMessage ? _c('b-form-textarea', {
    ref: "input",
    staticClass: "message-box",
    style: "--lines: ".concat(_vm.messageLines),
    attrs: {
      "placeholder": _vm.showTextPlaceholder,
      "disabled": !_vm.selectedChatroom.is_enabled || !_vm.canShowChatReply || !_vm.isSenderEnabled,
      "rows": "1"
    },
    on: {
      "keypress": _vm.handleInputKeypress
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }) : _vm._e()], 1), _vm.allowSendMessage ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "disabled": _vm.sending || !_vm.selectedChatroom.is_enabled || !_vm.canShowChatReply
    },
    on: {
      "click": _vm.send
    }
  }, [_c('svg', {
    attrs: {
      "width": "21",
      "height": "18",
      "viewBox": "0 0 21 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.17 6.22991L5.17001 0.449907C4.64029 0.230693 4.05884 0.167851 3.49451 0.26882C2.93018 0.369788 2.4066 0.630339 1.98575 1.01963C1.5649 1.40891 1.2644 1.91064 1.11983 2.4654C0.975262 3.02016 0.992675 3.60473 1.17001 4.14991L2.71001 8.99991L1.13001 13.8499C0.947881 14.3973 0.927422 14.9855 1.07108 15.5442C1.21475 16.1029 1.51644 16.6083 1.94001 16.9999C2.48465 17.505 3.19729 17.79 3.94001 17.7999C4.33474 17.7996 4.72554 17.7215 5.09001 17.5699L19.14 11.7899C19.6872 11.5623 20.1547 11.1778 20.4836 10.6848C20.8125 10.1919 20.988 9.61252 20.988 9.01991C20.988 8.42729 20.8125 7.84795 20.4836 7.35497C20.1547 6.862 19.6872 6.47747 19.14 6.24991L19.17 6.22991ZM4.36001 15.6999C4.18361 15.7727 3.99007 15.7934 3.80225 15.7598C3.61442 15.7261 3.44015 15.6394 3.30001 15.5099C3.168 15.3838 3.07304 15.2239 3.02545 15.0476C2.97785 14.8713 2.97943 14.6854 3.03001 14.5099L4.49001 9.99991H18.22L4.36001 15.6999ZM4.49001 7.99991L3.00001 3.52991C2.94943 3.35446 2.94785 3.16851 2.99545 2.99222C3.04304 2.81594 3.138 2.65606 3.27001 2.52991C3.36412 2.43118 3.47742 2.35275 3.60296 2.29944C3.7285 2.24613 3.86362 2.21906 4.00001 2.21991C4.13406 2.22016 4.26669 2.24737 4.39001 2.29991L18.22 7.99991H4.49001Z",
      "fill": "#09101D"
    }
  })])]) : _vm._e()])] : _vm._e()], 2)]), _c('div', {
    staticClass: "right-dragbar",
    on: {
      "mousedown": function mousedown($event) {
        _vm.isRightDragging = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    ref: "sideCol",
    staticClass: "side-col border-left"
  }, [_c('div', {
    staticClass: "side-col-wrapper"
  }, [_c('ChatroomSidebox', {
    ref: "sidebox",
    attrs: {
      "selected-chatroom": _vm.selectedChatroom,
      "chatroom-config": _vm.chatroomConfig,
      "show-file-list-in-dashboard": _vm.showFileListInDashboard,
      "show-member-list-in-dashboard": _vm.showMemberListInDashboard
    },
    on: {
      "updateMessageNickname": _vm.syncMessageNickname
    }
  })], 1)])]), _c('ImageLightBox', {
    ref: "lightbox"
  }), _c('ChatroomUrlModal', {
    ref: "chatroomUrlModal"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }